// src/components/ui/Divider.jsx
import "./Divider.css";

function Divider({ mt = 0, mb = 0 }) {
  return (
    <hr
      className="divider"
      style={{ marginTop: `${mt}px`, marginBottom: `${mb}px` }}
    />
  );
}

export default Divider;